import { graphql } from 'react-relay';

export const PreSignedFileUploadMutation = graphql`
  mutation PreSignedFileUploadMutation(
    $input: PreSignedFileUploadMutationInput!
  ) {
    PreSignedFileUpload(input: $input) {
      payload {
        url
        fields
      }
      error
    }
  }
`;
